<template>
  <div class="">
    page1
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {},
  created() {}
};
</script>
<style lang="less" scope></style>
